import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsStatTabComponent } from "./ds-stat-tab.component";
import { DsStatTabGroupComponent } from "../ds-stat-tab-group/ds-stat-tab-group.component";

@NgModule({
  declarations: [DsStatTabComponent, DsStatTabGroupComponent],
  imports: [CommonModule],
  exports: [DsStatTabComponent, DsStatTabGroupComponent],
})
export class DsStatTabModule {}
